const COMMON = [
  {path: 'my-workbench/PersonalCenter', meta: { name: "个人中心"}},
  {path: 'my-workbench/AuditItems', meta: { name: "审核事项"}},
  {path: 'data-cockpit/AttendanceRecord', meta: { name: "考勤记录"}},
]

export default COMMON


// WEBPACK FOOTER //
// ./src/router/mapping/common.js